define("shared/modifiers/scroll-to-top", ["exports", "ember-modifier"], function (_exports, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.scrollToTop = scrollToTop;
  0; //eaimeta@70e063a35619d71f0,"ember-modifier"eaimeta@70e063a35619d71f
  /**
   * ScrollToTopModifier will automatically scroll to the top of the chosen element.
   *
   * Usage:
   * Will force the targeted element to scroll to the top when the modifier is loaded in
   * <RandomElement {{scroll-to-top "#targetId"}} />
   * or
   * <RandomElement {{scroll-to-top ".targetClass"}} />
   * or
   * <RandomElement {{scroll-to-top "targetClass"}} /> (class name without dot - backward compatible)
   *
   * @param _element HTMLElement that the modifier is attached to (unused)
   * @param param1 Array containing the element selector (ID, class, or class name) to scroll to top
   */
  function scrollToTop(_element, _ref) {
    let [elementSelector] = _ref;
    // Normalize the selector: if it doesn't start with . or #, assume it's a class name
    const normalizedSelector = elementSelector.startsWith('.') || elementSelector.startsWith('#') ? elementSelector : `.${elementSelector}`;
    const targetElement = document.querySelector(normalizedSelector);
    if (targetElement) {
      targetElement.scrollTop = 0;
    }
  }
  const scrollToTopModifier = (0, _emberModifier.modifier)(scrollToTop, {
    eager: false
  });
  var _default = _exports.default = scrollToTopModifier;
});